type SnapshotLike<T> = {
  val(): Record<string, T> | null | undefined;
};

export type WithUid<T> = T & { uid: string };

const hashmapToArray = <T extends Record<string, unknown>>(
  successCallback: (items: Array<WithUid<T>>) => void,
) =>
  (snapshot: SnapshotLike<T>): void => {
    const hashmap = snapshot.val() || {};

    successCallback(
      Object.keys(hashmap)
        .map((key) => ({
          ...(hashmap[key] as T),
          uid: key,
        })),
    );
  };

export default hashmapToArray;
